import { useGetPermissions } from '../requests/permissions/getPermissions'

export const useCheckPermission = (permission: string) => {
  const { data: permissions, isLoading: isPermissionsLoading } =
    useGetPermissions()

  return (
    !isPermissionsLoading &&
    Array.isArray(permissions) &&
    permissions.includes(permission)
  )
}
